import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import * as _ from "lodash";
import moment from "moment";
// import useReactRouter from "use-react-router";

//apollo
import { CREATE_INVOICE } from "../../graphql/invoice/mutation";

import { Table, Form, Row, Col, Button, Card, Badge, Spinner } from "react-bootstrap";
import { GET_ORDERGROUPS } from "../../graphql/order/query";
import { convertCurrency, convertCurrentDate, NewCovertTimeZone, numberFormat, startDateAndEndDate } from "../../helpers";
import {
  convertOrderStatus,
  convertOrderType,
  convertPayment,
} from "../../helpers/orderStatus";
import { warningMessage } from "../../constants/SweetAlertConst";
import { errorTitleWithTextSwal } from "../../helpers/sweetalert";
import PaginationsV1 from "../../components/PaginationV1";
// import { UPDATE_MANY_ORDERGROUPS } from "../../graphql/order/mutation";
import ModalConfirmComponent from "../../components/ModalConfirmComponent";
import Swal from "sweetalert2";
import LoadingSpinner from "../../components/LoadingSpinner";
import { FaEye } from "react-icons/fa";
import OrderDetailModal from "./components/OrderDetailModal";
import { GET_SHOP_COMMISION_INFLUENCER } from "../../graphql/influencer/query";
import { calculateReportInfluencer } from "../../helpers/calculationReport";
import { MdOutlineDateRange } from "react-icons/md";
import CurrentDateModal from "../../components/currentComponent/CurrentDateModal";
// import { UPDATE_ORDERGROUP } from "../../graphql/order/mutation";
import { TOGGLE_STATUS_ORDER_GROUP } from "../../graphql/order/mutation";

function CreateInvoice() {
  const shop = JSON.parse(localStorage.getItem("SHOP_DATA"));
  const selectRef = useRef(null);

  //state for set values
  // set time default in this week
  const [filter, setFilter] = useState({
    createdAt_gte: startDateAndEndDate("week", "YYYY-MM-DD").startMonth,
    createdAt_lt: startDateAndEndDate("week", "YYYY-MM-DD").endMonth,
    payment: "",
    status: ["COMPLETED", "SHIPPINGCOMPLETED", "SHIPPING_COMPLETED"],
    type: "SALE_PAGE",
  });
  const [isCurrentModals, setIsCurrentModals] = useState(false);
  const [activeButton, setActiveButton] = useState("thisWeek");
  const [orderLists, setOrderLists] = useState([]);
  const [orderListsTotal, setOrderListsTotal] = useState(0);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [reportData, setReportData] = useState();
  const [selectAll, setSelectAll] = useState(false);
  const [showConfirmRemove, setShowConfirmRemove] = React.useState(false);
  // const [showUpdateStatus, setShowUpdateStatus] = React.useState(false);
  const [selectedInfluencer, setSelectedInfluencer] = useState();

  const handleCloseRemoveProduct = () => setShowConfirmRemove(false);

  // const [updateManyOrderGroups, { loading: updateorderManyLoading }] = useMutation(UPDATE_MANY_ORDERGROUPS);
  const [createInvoice, { loading: createLoading }] = useMutation(CREATE_INVOICE);

  const [
    getOrderGroupsData,
    { data: orderGroupData, loading: orderGroupLoading },
  ] = useLazyQuery(GET_ORDERGROUPS, {
    fetchPolicy: "network-only",
  });

  const { data: commisionInfluencer } = useQuery(GET_SHOP_COMMISION_INFLUENCER, {
    fetchPolicy: "cache-and-network",
    variables: {
      where: {
        shop: shop?.id,
      },
      orderBy: "createdAt_DESC",
      limit: 100,
      skip: 0,
    },
  });

  const rowsPerPage = 30;
  const [page, setPage] = useState(0);
  const pageAll =
    orderListsTotal > 0 ? Math.ceil(orderListsTotal / rowsPerPage) : 1;
  const handleChangePage = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  //useEffect for fetch data
  useEffect(() => {
    fetchOrderGroupsData();
  }, [
    shop?.id,
    filter?.searchText,
    filter?.getType,
    filter?.payment,
    filter?.status,
    filter?.createdAt_gte,
    filter?.createdAt_lt,
    page,
    selectedInfluencer
  ]);

  useEffect(() => {
    if (orderGroupData?.orderGroups) {
      setOrderLists(orderGroupData?.orderGroups?.data);
      setOrderListsTotal(orderGroupData?.orderGroups?.total);

      // calculate reports
      const report = calculateReportInfluencer(orderGroupData?.orderGroups?.data);
      setReportData(report)

    }
  }, [orderGroupData?.orderGroups]);

  // get ordergroups data
  const fetchOrderGroupsData = async () => {
    try {
      if (orderGroupLoading) return;
      let _where = {
        shop: shop?.id,
        isDeleted: false,
        type: "SALE_PAGE",
      }
      // default status to COMPLETED unless user selected another
      _where = {
        ..._where,
        status: _.isEmpty(filter?.status) ? ["COMPLETED", "SHIPPINGCOMPLETED", "SHIPPING_COMPLETED"] : filter?.status,
      };
      if (!_.isEmpty(filter?.searchText)) {
        _where = {
          ..._where,
          code: filter?.searchText,
        };
      }
      if (!_.isEmpty(filter?.getType)) {
        _where = {
          ..._where,
          typeForAffiliate: filter?.getType,
        }
      }
      if (!_.isEmpty(selectedInfluencer)) {
        _where = {
          ..._where,
          infulancer: selectedInfluencer?.id,
        }
      }

      if (!_.isEmpty(filter?.payment)) {
        _where = {
          ..._where,
          payment: filter?.payment,
        }
      }

      if (
        filter?.createdAt_gte !== "" &&
        filter?.createdAt_lt !== ""
      ) {
        _where = {
          ..._where,
          createdAt_gte: NewCovertTimeZone(filter?.createdAt_gte, "YYYY-MM-DD"),
          createdAt_lt: NewCovertTimeZone(filter?.createdAt_lt, "YYYY-MM-DD")
        };
      }

      await getOrderGroupsData({
        variables: {
          where: _where,
          limit: rowsPerPage,
          skip: page * rowsPerPage,
        },
      });

    } catch (error) {
      console.log("error--->", error);
    }
  };

  //function create invoice
  const handleCreateInvoice = async () => {
    if (createLoading) return;

    //validate check data before create invoice
    if (selectedOrders.length <= 0)
      return warningMessage("ກະລຸນາເລືອກລາຍການກ່ອນ !");
    //calulate total money before send api
    const totalKip = selectedOrders.reduce(
      (acc, order) => acc + order.totalPrice,
      0
    );

    const totalBathPlusUsd = selectedOrders.reduce((acc, order) => {
      if (order.sumPriceBaht !== 0) {
        acc += order.sumPriceBaht * order.exchangeRate?.baht;
      }
      if (order.sumPriceUsd !== 0) {
        acc += order.sumPriceUsd * order.exchangeRate?.usd;
      }
      return acc;
    }, 0);

    let totalMoney = totalKip + totalBathPlusUsd;

    //get id order
    const orderId = selectedOrders.map((order) => order.id);

    //prepare data before update
    let _data = {
      totalMoney: totalMoney,
      status: "REQUEST",
      percent: 3,
      orderGroups: orderId,
      shop: shop?.id,
      shopName: shop?.name,
    };
    //try create invoice
    try {
      const result = await createInvoice({
        variables: {
          data: _data,
        },
      });

      if (result?.data?.createInvoices?.id) {
        setShowConfirmRemove(false);
        Swal.fire({
          title: "ສຳເລັດ",
          text: "ສ້າງໃບຖອນເງິນສຳເລັດ",
          icon: "success",
          showConfirmButton: false,
          timer: 1800,
        }).then((values) => {
          fetchOrderGroupsData();
          setSelectedOrders([]);
          setSelectAll(false);
        });
      }
    } catch (err) {
      console.log("error--->", err);
      errorTitleWithTextSwal({
        title: "ບໍ່ສາມາດສ້າງໃບຖອນເງິນໄດ້",
        text: "ກະລຸນາຕິດຕໍ່ຜູ້ໃຫ້ບໍລິການ",
      });
    }
  };

  // Create a debounced search function
  const debouncedSearch = useCallback(
    _.debounce((text) => {
      setFilter(prev => ({ ...prev, searchText: text }));
    }, 500),
    []
  );

  const summaryStyle = { fontSize: 16, fontWeight: 'bold', color: "green" };

  return (
    <>
      <div>
        <div style={{ padding: "0 9px" }}>

          <Row className="g-3">
            <Col xs={12} md={6} lg={4}>
              <Form.Group>
                <Form.Label>ຄົ້ນຫາ</Form.Label>
                <Form.Control
                  onChange={(e) => {
                    debouncedSearch(e.target.value);
                  }}
                  value={filter?.searchText}
                  type="text"
                  placeholder="ປ້ອນເລກໃບສັ່ງຊື້ ຫຼື ຊື່ລູກຄ້າ..."
                />
              </Form.Group>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <Row className="g-2">
                <Col xs={12} sm={6}>
                  <Form.Group>
                    <Form.Label>ຊ່ອງທາງອໍເດີ້</Form.Label>
                    <Form.Select
                      onChange={(e) => {
                        setFilter({ ...filter, getType: e.target.value });
                      }}>
                      <option value="ORDER_NOMAL">ອໍເດີ້ຂອງຮ້ານ</option>
                      <option value="ORDER_AFFILIATE">ອໍເດີ້ຂອງ ອາຟຣິລີເອດ</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={6}>
                  <Form.Group>
                    <Form.Label>ລາຍຊື່ອິນຟູ</Form.Label>
                    <Form.Select
                      disabled={filter?.getType === "ORDER_AFFILIATE" ? false : true}
                      onChange={(e) => {
                        const selectedId = e.target.value;
                        const influencer = commisionInfluencer?.shopSettingCommissionInfulancers?.data.find(
                          item => item.infulancer.id === selectedId
                        );
                        setSelectedInfluencer(influencer?.infulancer || null);
                        setFilter({ ...filter, influencerId: selectedId });
                      }}>
                      <option value="">ເລືອກອິນຟູ</option>
                      {commisionInfluencer?.shopSettingCommissionInfulancers?.data?.map((item, index) => (
                        <option key={index} value={item?.infulancer?.id}>
                          {item?.infulancer?.first_name} {item?.infulancer?.last_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <Form.Group>
                <Form.Label>ວັນທີ່</Form.Label>
                <Button
                  variant="outline-secondary"
                  onClick={() => setIsCurrentModals(true)}
                  style={{ textAlign: "left", marginTop: '-.2em', width: '100%' }}
                >
                  {(orderGroupLoading) ? (
                    <Spinner size="sm" />
                  ) : (
                    <MdOutlineDateRange style={{ fontSize: 24 }} />
                  )}
                  &nbsp;  &nbsp;
                  {(filter?.createdAt_gte === "" && filter?.createdAt_lt === "") ? (
                    <span style={{ fontSize: 14 }}>ຄົ້ນຫາຕາມວັນທີ່...</span>
                  ) : (
                    <span style={{ fontSize: 14 }}>
                      {convertCurrentDate(filter?.createdAt_gte) +
                        " - " +
                        convertCurrentDate(filter?.createdAt_lt)}
                    </span>
                  )}
                </Button>
              </Form.Group>
            </Col>
          </Row>
          {/* Payment & Status filters */}
          <Row className="g-3" style={{ marginTop: "5px" }}>
            <Col xs={12} md={6} lg={4}>
              <Form.Group>
                <Form.Label>ການຈ່າຍ</Form.Label>
                <Form.Select
                  value={filter?.payment || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFilter(prev => ({ ...prev, payment: value }));
                  }}>
                  <option value="">ເລືອກການຈ່າຍ</option>
                  <option value="COD">{convertPayment("COD")}</option>
                  <option value="TRANSFER">{convertPayment("TRANSFER")}</option>
                  <option value="OTHER">{convertPayment("OTHER")}</option>
                  <option value="CASH">{convertPayment("CASH")}</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col xs={12} md={6} lg={4}>
              <Form.Group>
                <Form.Label>ສະຖານະອໍເດີ້</Form.Label>
                <Form.Select
                  value={filter?.status || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFilter(prev => ({ ...prev, status: value }));
                  }}>
                  <option value="">ເລືອກສະຖານະອໍເດີ້</option>
                  <option value="CART">{convertOrderStatus("CART") || "CART"}</option>
                  <option value="PAYMENT_PROCESSING">{convertOrderStatus("PAYMENT_PROCESSING") || "PAYMENT_PROCESSING"}</option>
                  <option value="CREATED">{convertOrderStatus("CREATED") || "CREATED"}</option>
                  <option value="WAITINGCONFIRM">{convertOrderStatus("WAITINGCONFIRM") || "WAITINGCONFIRM"}</option>
                  <option value="PACKING">{convertOrderStatus("PACKING") || "PACKING"}</option>
                  <option value="READY_TO_SHIPPING">{convertOrderStatus("READY_TO_SHIPPING") || "READY_TO_SHIPPING"}</option>
                  <option value="SHIPPING">{convertOrderStatus("SHIPPING") || "SHIPPING"}</option>
                  <option value="SHIPPING_COMPLETED">{convertOrderStatus("SHIPPING_COMPLETED") || "SHIPPING_COMPLETED"}</option>
                  <option value="SHIPPING_ADDRESS_ERROR">{convertOrderStatus("SHIPPING_ADDRESS_ERROR") || "SHIPPING_ADDRESS_ERROR"}</option>
                  <option value="COMPLETED">{convertOrderStatus("COMPLETED") || "COMPLETED"}</option>
                  <option value="CANCELLED">{convertOrderStatus("CANCELLED") || "CANCELLED"}</option>
                  <option value="USERCONFIRM">{convertOrderStatus("USERCONFIRM") || "USERCONFIRM"}</option>
                  <option value="NO_PAID">{convertOrderStatus("NO_PAID") || "NO_PAID"}</option>
                  <option value="IMAGE_NOT_YET_PAID">{convertOrderStatus("IMAGE_NOT_YET_PAID") || "IMAGE_NOT_YET_PAID"}</option>
                  <option value="PAYMENT_STILL_INCOMPLETE">{convertOrderStatus("PAYMENT_STILL_INCOMPLETE") || "PAYMENT_STILL_INCOMPLETE"}</option>
                  <option value="PRINT_ORDER">{convertOrderStatus("PRINT_ORDER") || "PRINT_ORDER"}</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row style={{ marginTop: "5px", marginBottom: "5px" }}>
            <Col>
              {/* card info influencer  */}
              <Card style={{ boxShadow: "none" }}>
                <Card.Header>ຂໍ້ມູນ ອາຟຣີລີແອດ</Card.Header>
                <Card.Body>
                  {selectedInfluencer ? (
                    <>
                      <Card.Title>ຊື່: {selectedInfluencer.first_name} {selectedInfluencer.last_name}</Card.Title>
                      <Card.Text>
                        <h6>ເບີໂທ: {selectedInfluencer.phone || '-'}</h6>
                        <h6>ທີ່ຢູ່: {selectedInfluencer.village_name || '-'}, {selectedInfluencer.district_name || '-'}, {selectedInfluencer.province_name || '-'} </h6>
                        {/* <h6>ຄ່າຄອມ: {selectedInfluencer.commission_rate || '-'}%</h6> */}
                      </Card.Text>
                    </>
                  ) : (
                    <Card.Text>ກະລຸນາເລືອກອິນຟູເພື່ອເບິ່ງຂໍ້ມູນ</Card.Text>
                  )}
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card style={{ boxShadow: "none" }}>
                <Card.Header>ສະຫຼຸບຍອດ</Card.Header>
                <Card.Body>
                  <Card.Text>
                    <h5 className="d-flex w-full justify-content-between"><span style={summaryStyle}>ອໍເດີ້ທີ່ໄດ້:</span> <span style={summaryStyle}>{reportData?.resultOrder || 0} ລາຍການ</span> </h5>
                    <h5 className="d-flex w-full justify-content-between"><span style={summaryStyle}>ຍອດສີນຄ້າ:</span> <span style={summaryStyle}>{reportData?.totalStock || 0} ທັງຫທົດ</span> </h5>
                    <h5 className="d-flex w-full justify-content-between"><span style={summaryStyle}>ຍອດເງິນຂອງຮ້ານ:</span> <span style={summaryStyle}>{numberFormat(reportData?.sumPriceShop || 0)} ກີບ</span></h5>
                    <h5 className="d-flex w-full justify-content-between"><span style={{fontSize: 16, fontWeight: 'bold', color: "red"}}>ຍອດເງິນອາຟຣີລີແອດ:</span> <span style={{fontSize: 16, fontWeight: 'bold', color: "red"}}>{numberFormat(reportData?.sumPriceInfluencer || 0)} ກີບ</span></h5>
                    <div />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* show list invoice */}
          <ListOrder
            orderLists={orderLists}
            setOrderLists={setOrderLists}
            createLoading={createLoading}
            orderListsTotal={orderListsTotal}
            orderGroupLoading={orderGroupLoading}
            selectRef={selectRef}
            selectedOrders={selectedOrders}
            setSelectedOrders={setSelectedOrders}
            selectAll={selectAll}
            setSelectAll={setSelectAll}
            rowsPerPage={rowsPerPage}
            page={page}
            refetch={getOrderGroupsData} // Passed refetch prop
          />
          {/* show list invoice */}
          {orderLists?.length > 0 ? (
            <PaginationsV1
              count={orderListsTotal}
              rowsPerPage={rowsPerPage}
              page={page}
              pageAll={pageAll}
            onPageChange={handleChangePage}
          />
          ) : (
            <p style={{ color: "gray", fontWeight: 'bold'}} >!ບໍ່ພົບຂໍ້ມູນ</p>
          )}
        </div>
      </div>

      <ModalConfirmComponent
        showConfirmModal={showConfirmRemove}
        handleCancel={handleCloseRemoveProduct}
        loadingConfirm={createLoading}
        handleConfirm={handleCreateInvoice}
        title="ແຈ້ງເຕືອນ"
        text="ຕ້ອງການສ້າງອິນວອຍ (invoice) ນີ້ແທ້ບໍ?"
      />

      {/* modal current date  */}
      <CurrentDateModal
        onCloseModal={() => setIsCurrentModals(false)}
        openModal={isCurrentModals}
        setCdFillter={setFilter}
        setActiveButton={setActiveButton}
        activeButton={activeButton}
        backdrop={true}
      />

    </>
  );
}

export default CreateInvoice;

const statusWait = () => {
  return <div style={{ color: "gray", fontSize: ".8em" }}>ຍັງບໍ່ທັນແຈ້ງຖອນ</div>;
};

const statusRequest = () => {
  return <div style={{ color: "orange", fontSize: ".8em" }}>ແຈ້ງຖອນແລ້ວ</div>;
};

const statusReject = () => {
  return <div style={{ color: "red", fontSize: ".8em" }}>ຖືກປະຕິເສດ</div>;
};

const statusApproved = () => {
  return <div style={{ color: "green", fontSize: ".8em" }}>ຢືນຢັນການຖອນແລ້ວ</div>;
};

const viewsStatus = {
  WAITING: statusWait,
  REQUEST: statusRequest,
  REJECT: statusReject,
  APPROVED: statusApproved,
};

const ListOrder = ({
  orderLists,
  setOrderLists,
  orderGroupLoading,
  createLoading,
  rowsPerPage,
  page,
  refetch,
}) => {
  const [toggleStatusOrderGroup, { loading: toggleLoading }] = useMutation(TOGGLE_STATUS_ORDER_GROUP);
  const [orderObj, setOrderObj] = useState({
    open: false,
    datas: null,
  })

  const tableItemOrderStyle = {
    borderRadius: ".2em",
    fontSize: ".6em",
  }

  //checkStatus
  const checkStatus = (status) => {
    const CurrenctStatus = viewsStatus[status];
    return <CurrenctStatus />;
  };

  const handleCommission = (item) => {
    const commission = item?.sumPrice * (parseInt(item?.infulancer_percent) / 100);
    const newCommission = item?.totalAffiliate !== commission ? commission : item?.totalAffiliate;
    return numberFormat(newCommission);
  }

  const handleChangeInvoiceStatus = async (item, value) => {
    if (toggleLoading) return;
    if (value === "CART") return;

    const orderId = item?.id;
    try {
      const res = await toggleStatusOrderGroup({
        variables: {
          where: { id: orderId },
          data: { status: value }
        }
      });

      const result = res?.data?.toggleStatusOrderGroup;

      if (result?.status && result?.dataOne) {
        Swal.fire({
          icon: "success",
          title: "ອັບເດດສະຖານະສຳເລັດ",
          showConfirmButton: false,
          timer: 1200,
        });

        if (result?.dataOne?.status === value) {
          setOrderLists(orderLists.map((item) => item.id === orderId ? { ...item, status: value, ...(value === "CREATED" ? { isPaymented: true } : {}) } : item));
        }

        // Refetch to update the list with server data
        // refetch();
      } else {
        Swal.fire({
          icon: "error",
          title: "ອັບເດດສະຖານະຜິດພາດ",
          text: result?.msg || result?.err || "ກະລຸນາລອງໃໝ່",
        });
      }
    } catch (error) {
      console.log("update invoiceStatus error", error);
      Swal.fire({
        icon: "error",
        title: "ອັບເດດສະຖານະຜິດພາດ",
        text: "ກະລຸນາລອງໃໝ່",
      });
    }
  };

  if (orderGroupLoading || createLoading)
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        <LoadingSpinner />
      </div>
    );

  return (
    <React.Fragment>

      <Table responsive>
        <thead>
          <tr style={{ whiteSpace: "nowrap" }}>
            <td style={{ borderBottom: "1px solid #eeeeee" }}>
              ລຳດັບ
            </td>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ເລກໃບສັ່ງຊື້</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ອາຟຣິລີເອດ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ປະເພດ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ສະຖານະອໍເດີ້</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ຈຳນວນເງີນ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ເປີເຊັນຄອມມິດຊັ່ນ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ເງີນຄອມມິດຊັ່ນ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ວັນທີສັ່ງຊື້</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ລາຍການ</th>
            <th style={{ borderBottom: "1px solid #eeeeee" }}>ແຈ້ງຖອນ</th>
            <th style={{ borderBottom: "1px solid #eeeeee", textAlign: "center" }}>ຈັດການ</th>
          </tr>
        </thead>
        <tbody>
          {orderLists?.map((item, index) => (
            <tr key={item?.id}>
              <td>
                {page * rowsPerPage + index + 1}
              </td>
              <td>
                <Badge bg="secondary">{item?.code}</Badge>
              </td>
              <td>
                <Badge bg="secondary">{item?.infulancer?.first_name || item?.affiliateName ||  "-"}  {item?.infulancer?.last_name}</Badge>
              </td>
              <td>
                <Badge bg="secondary">
                {convertOrderType(item?.type)}
                </Badge> 
              </td>
              <td style={{ fontWeight: "bold", textAlign: "center" }}>
                <span
                  style={{
                    background:
                      item?.status === "COMPLETED" ? "#179b3f" : "#fff",
                    color: item?.status === "COMPLETED" ? "white" : "#333",
                    // padding: ".2em",
                    borderRadius: ".3em",
                    fontSize: ".8em",
                    padding: "0.2em 0.6em", display: "block", width: "fit-content", margin: "0 auto" 
                  }}>
                  {convertOrderStatus(item?.status ?? "-")}
                </span>
              </td>
              <td style={{ fontWeight: "bold", textAlign: "center" }}>
                <Badge bg={item?.isPaymented ? "success" : "danger"} style={{ padding: "0.2em 0.6em", display: "block", width: "fit-content", margin: "0 auto" }}>
                  ₭ {new Intl.NumberFormat("en-US").format(item?.sumPrice ?? 0)}
                </Badge>
                <p style={{ marginTop: "4px", textAlign: "center" }}>{item?.isPaymented ? "ຊຳລະ" : "ຍັງບໍ່ຊຳລະ"}</p>
              </td>
              <td><Badge bg="danger">{item?.typeForAffiliate === "ORDER_AFFILIATE" ? item?.infulancer_percent || 0 : 0}%</Badge></td>
              <td><Badge bg="danger">₭ {item?.typeForAffiliate === "ORDER_AFFILIATE" ? handleCommission(item) : 0}</Badge></td>
              <td>
                <Badge bg="secondary">{moment(item?.createdAt).format("DD/MM/YYYY HH:mm")}</Badge>
              </td>
              <td>
                {
                  <Table responsive>
                    <thead>
                      <tr>
                        <th><Badge bg="warning" text="dark" style={tableItemOrderStyle}>ລຳດັບ</Badge></th>
                        <th><Badge bg="warning" text="dark" style={tableItemOrderStyle}>ຊື້ສິນຄ້າ</Badge></th>
                        <th><Badge bg="warning" text="dark" style={tableItemOrderStyle}>ຈຳນວນ</Badge></th>
                        <th><Badge bg="warning" text="dark" style={tableItemOrderStyle}>ລາຄາ</Badge></th>
                      </tr>
                    </thead>
                    <tbody>
                      {item?.orders?.map((order, index) => (
                        <tr key={index}>
                          <td><Badge bg="white" text="dark" style={tableItemOrderStyle} >{index + 1}</Badge></td>
                          <td><Badge bg="white" text="dark" style={tableItemOrderStyle}>{order?.productName || order?.stock?.name || '-'}</Badge></td>
                          <td><Badge bg="white" text="dark" style={tableItemOrderStyle}>{order?.amount || '0'}</Badge></td>
                          <td><Badge bg="white" text="dark" style={tableItemOrderStyle}>{order?.price || '0'}{' '}{convertCurrency(order?.currency || '₭')}</Badge></td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                }
              </td>
              <td>{checkStatus(item.invoiceStatus || "WAITING")}</td>
              <td align="right">
                <Button
                  style={{
                    borderRadius: ".2em",
                    fontSize: ".8em",
                  }}
                  onClick={() => setOrderObj({ open: true, datas: item })}
                  variant="light">
                  <FaEye /> ລາຍລະອຽດ
                </Button>
                {" "}
                <Form.Select
                  size="sm"
                  style={{ display: "inline-block", width: "auto", marginLeft: ".4em" }}
                  value={item?.status || "CART"}
                  onChange={async (e) => {
                    const value = e.target.value;
                    try {
                      const { isConfirmed } = await Swal.fire({
                        icon: "warning",
                        title: "ຢືນຢັນການປ່ຽນສະຖານະອໍເດີ?",
                        text: `ຈະປ່ຽນເປັນ: ${convertOrderStatus(value)}`,
                        showCancelButton: true,
                        confirmButtonText: "ຕົກລົງ",
                        cancelButtonText: "ຍົກເລີກ",
                      });

                      if (isConfirmed) {
                        handleChangeInvoiceStatus(item, value);
                      }
                    } catch (err) {
                      console.log("confirm change status error", err);
                      Swal.fire({
                        icon: "error",
                        title: "ຜິດພາດ",
                        text: "ກະລຸນາລອງໃໝ່",
                      });
                    }
                  }}
                  disabled={toggleLoading}
                >
                  <option value="CART">ກະຕ່າກຽມແພັກ</option>
                  <option value="CREATED">ຮັບອໍເດີ</option>
                  <option value="SHIPPING">ຈັດສົ່ງ</option>
                  <option value="SHIPPING_COMPLETED">ສົ່ງສຳເລັດ</option>
                  <option value="COMPLETED">ອໍເດີສຳເລັດ</option>
                  <option value="RETURN">ອໍເດີສົ່ງຄືນ</option>
                  {item?.status === "CART" && <option value="REJECT">ປະຕິເສດ</option>}
                </Form.Select>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <OrderDetailModal datas={orderObj.datas} open={orderObj.open} handleClose={() => setOrderObj({ open: false, datas: null })} />
    </React.Fragment>
  );
};

